/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { ArgumentTypes, FunctionPlugin } from './FunctionPlugin';
export class IsEvenPlugin extends FunctionPlugin {
    iseven(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('ISEVEN'), (val) => (val % 2 === 0));
    }
}
IsEvenPlugin.implementedFunctions = {
    'ISEVEN': {
        method: 'iseven',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER }
        ]
    },
};
